export function getProductImage(currentImage: string, pictureObject: ImageObject) {
  return currentImage || pictureObject.url || '/images/dummy-image-1x1.jpg';
}

export function buildLink(target: string, isWebshop: boolean): Link {
  if (isWebshop) {
    return {
      target,
      type: 'external_link',
      window: '_blank',
    };
  }

  return {
    target,
    type: 'internal_link',
  };
}
